import styled from 'styled-components';

/**
 * A container div that adds default styles for Markdown markup.
 */
const MarkdownContainer = styled.div`
  font-family: 'Calibre';
  font-weight: 400;
  font-size: 18px;
  line-height: 1.5rem;

  a,
  blockquote,
  code,
  em,
  li,
  ol,
  p,
  pre,
  strong,
  ul {
    font-size: inherit;
  }

  strong {
    font-weight: bold;
  }

  p {
    margin: 18px 0;

    &:first-child {
      margin-top: 0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 32px 0 16px;
    padding: 0;

    &:first-child {
      margin-top: 0;
    }
  }

  ul,
  ol {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  blockquote {
    padding-left: 40px;
  }

  code {
    font-family: monospace;
  }

  p > img {
    box-shadow: 0 4px 10px -2px #000;
    border-radius: 5px 5px 5px 5px;
    width: 50%;
    margin-right: 25%;
    margin-left: 25%;

    @media ${(props) => props.theme.breakpoints.isMobile} {
      width: 90%;
      margin-right: 5%;
      margin-left: 5%;
    }
  }

  table {
    border-spacing: 0;
    border-collapse: collapse;
  }

  th,
  td {
    border: 1px solid ${(props) => props.theme.midGrey};
    padding: 0.7em;
  }

  hr {
    border: none;
    border-bottom: 1px solid currentColor;
    padding: 10px;
    margin: 0;
  }
`;

export default MarkdownContainer;
